const IcBackArrow = (props: any) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.233 19.5455C11.7937 19.9848 11.0813 19.9848 10.642 19.5455L3.89201 12.7955C3.45267 12.3562 3.45267 11.6438 3.89201 11.2045L10.642 4.45451C11.0813 4.01517 11.7937 4.01517 12.233 4.45451C12.6723 4.89384 12.6723 5.60616 12.233 6.04549L6.27849 12L12.233 17.9545C12.6723 18.3938 12.6723 19.1062 12.233 19.5455Z'
      fill='#232F3E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.4375 12C20.4375 12.6213 19.9338 13.125 19.3125 13.125L5.625 13.125C5.00368 13.125 4.5 12.6213 4.5 12C4.5 11.3787 5.00368 10.875 5.625 10.875L19.3125 10.875C19.9338 10.875 20.4375 11.3787 20.4375 12Z'
      fill='#232F3E'
    />
  </svg>
);

export default IcBackArrow;
